// React dependencies
import React from 'react';

// External dependencies
import PropTypes from 'prop-types';

// Internal dependencies
import Colours from '../../../../../styles/colours';
import MText from '../../../../../components/Common/MText';
import PoiButton from '../PoiButton';

const SameAsPreviousAlert = (props) => (
  <div
    className="p-2 rounded-lg"
    style={{
      backgroundColor: Colours.White,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'space-around',
      border:          '1px solid #EEEEEE',
    }}
  >
    <MText size={14} colour={Colours.Black} bold>
      Same as previous?
    </MText>
    <PoiButton
      style={{ borderRadius: 99 }}
      className="px-2"
      onClick={props.onUseSamePreviousLocation}
      text="Yes"
    />
  </div>
);

SameAsPreviousAlert.propTypes = {
  onUseSamePreviousLocation: PropTypes.func.isRequired,
};

export default SameAsPreviousAlert;
